import { DashboardHeader } from '@modules/admin/Admin.Header'
import AccessControl from '@modules/auth/AccessControl'
import CustomModal from '@modules/core/components/CustomModalComponent'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { history } from '@services/History'

class DerivationShow extends Component {
  state = {
    id: this.props.match.params.derivationId,
    derivation: undefined,
    deleteModal: false,
  }

  handleToggleModal = () => {
    this.setState((prevState) => ({ deleteModal: !prevState.deleteModal }))
  }

  handleDelete = () => {
    Consultations.externalDerivations
      .delete(this.state.id)
      .then(() => history.push('/derivations'))
      .catch((err) => window.alert(err.message))
  }

  componentDidMount() {
    Consultations.externalDerivations
      .show(this.state.id)
      .then((res) => this.setState({ derivation: res.data }))
      .catch((err) => window.alert(err.message))
  }

  render() {
    const { derivation } = this.state
    if (!derivation) return null
    return (
      <div className="crud-wrapper professional-wrapper">
        <div className="professional-show">
          <DashboardHeader title={<Trans>Ver Derivación</Trans>}>
            <AccessControl exclusiveCompanies={[derivation.company]}>
              <Link to={`/derivations/update/${this.state.id}`} className="btn btn-primary">
                <Trans>Editar</Trans>
              </Link>
              <button className="btn btn-danger" onClick={() => this.setState({ deleteModal: true })}>
                <Trans>Borrar</Trans>
              </button>
            </AccessControl>
            <Link to={`/derivations`} className="btn btn-primary">
              <Trans>Volver</Trans>
            </Link>
          </DashboardHeader>

          {this.state.deleteModal && (
            <CustomModal
              title={<Trans>¿Estás seguro que quieres borrar este registro?</Trans>}
              active={true}
              actionOnClickClose={() => this.setState({ deleteModal: false })}
              actionOnClickAccept={this.handleDelete}
            />
          )}

          <div className="container-fluid main-content">
            <div className="form-crud well">
              <div className="form-group">
                <label>
                  <Trans>Mensaje</Trans>
                </label>
                <span>{derivation.message}</span>
              </div>

              <div className="form-group">
                <label>
                  <Trans>Teléfono</Trans>
                </label>
                <span>{derivation.phone_value || '--'}</span>
              </div>

              <div className="form-group">
                <label>
                  <Trans>Url</Trans>
                </label>
                <a href={derivation.url_value} target={'_blank'} rel="noopener noreferrer">
                  {derivation.url_value || '--'}
                </a>
              </div>

              <AccessControl role="super-admin">
                <div className="form-group">
                  <label>
                    <Trans>Compañía</Trans>
                  </label>
                  <span>{derivation.company.name}</span>
                </div>
              </AccessControl>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(DerivationShow)
